import { useState, useEffect, useRef } from "react";
import "../../assets/css/views/activations/activationsCreation.css";
import { useTranslation } from "react-i18next";
import {
  Button,
  Table,
  TableData,
  TableColumns,
  TablePreferences,
  TableColumnWidth,
  Modal,
  IconX,
  IconWarningAlt,
  Card,
  FilePicker,
  IconCheckmark,
  ContextualMenu,
  TextBox,
  OptionInterface,
  IconPencil,
  IconTrash,
  ButtonGroup,
  RadioButtons,
  RadioButton,
  Checkbox,
  ListItem,
  List,
  TextArea,
  IconSearch,
  IconPlus,
  Toggle,
  CustomImage,
  Select,
  SelectOption,
  Tooltip,
  IconInfo,
} from "@veneer/core";
import activationsService from "../../services/agendaApi/activations.service";
import { IActivationDto } from "../../models/dto/agendaApi/IActivationDto";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { IActivationCategoryDto } from "../../models/dto/agendaApi/IActivationCategoryDto";
import { IActivationFundDto } from "../../models/dto/agendaApi/IActivationFundDto";
import { IActivationFamilyDto } from "../../models/dto/agendaApi/IActivationFamilyDto";
import { IActivationTypeDto } from "../../models/dto/agendaApi/IActivationTypeDto";
import { IActivationTechnologyDto } from "../../models/dto/agendaApi/IActivationTechnologyDto";
import {
  IActivationProductDto,
} from "../../models/dto/agendaApi/IActivationProductDto";
import {
  IActivationIn,
  IActivationUpdateIn,
} from "../../models/input/agendaApi/IActivationIn";
import LoaderModal from "../../components/Loader/loaderModal";
import ImageService from "../../services/generalApi/image.service";
import Loader from "../../components/Loader/loader";
import { IActivationsClassificationOptionsDto } from "../../models/dto/agendaApi/IActivationsClassificationOptionsDto";

export default function ActivationsCreation() {
  const [t] = useTranslation("global");
  type SelectValue = number | string | boolean;
  const languageId: any = useSelector((state: RootState) => state.languageId);

  //Data
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
  const [viewCreationModal, setViewCreationModal] = useState<number>(0);
  const [categories, setCategories] = useState<IActivationCategoryDto[]>([]);
  const [classificationOptions, setClassificationOptions] = useState<
    IActivationsClassificationOptionsDto[]
  >([]);
  const [funds, setFunds] = useState<IActivationFundDto[]>([]);
  const [families, setFamilies] = useState<IActivationFamilyDto[]>([]);
  const [types, setTypes] = useState<IActivationTypeDto[]>([]);
  const [technologies, setTechnologies] = useState<IActivationTechnologyDto[]>(
    []
  );
  const [productsSelected, setProductsSelected] = useState<
    IActivationProductDto[]
  >([]);
  const [productsSearch, setProductsSearch] = useState<IActivationProductDto[]>(
    []
  );
  const [fileValue, setFileValue] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>("");
  const [urlFile, setUrlFile] = useState<string | null>(null);
  const [printProductsSelected, setPrintProductsSelected] = useState<
    IActivationProductDto[]
  >([]);
  const [printProductsSearch, setPrintProductsSearch] = useState<
    IActivationProductDto[]
  >([]);
  const [isMarketingActivation, setIsMarketingActivation] =
    useState<boolean>(false);

  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [otherFund, setOtherFund] = useState<string>("");

  const activations = useRef<IActivationDto[]>([]);

  //Loadings
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingForEdit, setLoadingForEdit] = useState(false);
  const [loadingPrintProducts, setLoadingPrintProducts] = useState(false);

  //editing
  const [editing, setEditing] = useState(false);

  const [numberModel, setNumberModel] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const [printModel, setPrintModel] = useState<string>("");
  const [activationId, setActivationId] = useState<number>(NaN);

  //errors
  const [errorFilePicker, setErrorFilePicker] = useState(false);
  const [errorSearchProducts, setErrorSearchProducts] = useState(false);
  const [errorSearchPrintProducts, setErrorSearchPrintProducts] =
    useState(false);

  //selects
  const [categorySelected, setCategorySelected] = useState<number>(1);
  const [typeSelected, setTypeSelected] = useState<number>(NaN);
  const [classificationSelected, setClassificationSelected] =
    useState<number>(NaN);

  //Loadings
  const [loadingTableData, setLoadingTableData] = useState(true);

  //shows
  const [showModalCreateActivation, setShowModalCreateActivation] =
    useState(false);
  const [showModalDeleteActivation, setShowModalDeleteActivation] =
    useState(false);
  const [showModalProducts, setShowModalProducts] = useState(false);
  const [showModalPrintProducts, setShowModalPrintProducts] = useState(false);

  //Disables
  const [creationDisable, setCreationDisable] = useState(true);
  const [validateDisable, setValidateDisable] = useState(true);
  const [searchProductsDisable, setSearchProductsDisable] = useState(true);
  const [validateFunds, setValidateFunds] = useState(true);
  const [validateSubcategories, setValidateSubcategories] = useState(true);
  const [validateFamilies, setValidateFamilies] = useState(true);
  const [validateTypes, setValidateTypes] = useState(true);
  const [validateTechnologies, setValidateTechnologies] = useState(true);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [searchPrintProductsDisable, setSearchPrintProductsDisable] =
    useState(true);
  const [validateClassification, setValidateClassification] = useState(true);

  //search
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    getActivationsData();
    getCreationData();
  }, []);

  useEffect(() => {
    if (loadingForEdit === false) {
      setProductsSelected([]);
      setProductsSearch([]);
      setPrintProductsSelected([]);
      setPrintProductsSearch([]);

      setNumberModel("");
      setModel("");
      setPrintModel("");

      const categoriesTemp: IActivationCategoryDto[] = categories.map(
        (category) => ({
          ...category,
          selected: false,
        })
      );
      setCategories(categoriesTemp);
    }
  }, [categorySelected]);

  useEffect(() => {
    if (categories.some((item) => item.selected === true)) {
      let subcategoriesTemp = categories.filter((sub) => sub.selected === true);
      const SubcategoryList: number[] = subcategoriesTemp.map(
        (item) => item.categoryID
      );
      const SubcategoryListJson = { SubcategoryList: SubcategoryList };
      activationsService
        .getActivationFamilies(
          JSON.stringify(SubcategoryListJson),
          languageId.value
        )
        .then((r) => {
          const families = r.map((family: IActivationFamilyDto) => ({
            ...family,
            selected: false,
          }));
          setFamilies(families);
        });
    }
  }, [categories]);

  useEffect(() => {
    if (loadingForEdit === false) {
      if (categorySelected) {
        activationsService
          .getActivationTypes(categorySelected, languageId.value)
          .then((r) => {
            setTypes(r);
          });
        activationsService
          .getActivationTechnologies(categorySelected, languageId.value)
          .then((r) => {
            const technologies = r.map(
              (technology: IActivationTechnologyDto) => ({
                ...technology,
                selected: false,
              })
            );
            setTechnologies(technologies);
          });
      }
    }
  }, [categorySelected, languageId.value]);

  //useEffect for validate search products parameters
  useEffect(() => {
    setErrorSearchProducts(false);
    if (
      (numberModel &&
        numberModel.length === 2 &&
        model &&
        model.length === 1) ||
      model.length === 2
    ) {
      setSearchProductsDisable(false);
    } else {
      setSearchProductsDisable(true);
    }
  }, [numberModel, model]);

  //useEffect for validate search print products parameter
  useEffect(() => {
    setErrorSearchPrintProducts(false);
    if (printModel && printModel.length > 2) {
      setSearchPrintProductsDisable(false);
    } else {
      setSearchPrintProductsDisable(true);
    }
  }, [printModel]);

  //useEffect for validate data
  useEffect(() => {
    if (name && description) {
      if (fileName && urlFile) {
        setValidateDisable(false);
      } else if (!fileName && !urlFile) {
        setValidateDisable(false);
      } else if ((fileName && !urlFile) || (!fileName && urlFile)) {
        setValidateDisable(true);
      }
    } else {
      setValidateDisable(true);
    }
  }, [name, description, fileName, urlFile]);

  useEffect(() => {
    if (fileValue) {
      const formData = new FormData();
      formData.append("formFile", fileValue);
      try {
        setLoadingImage(true);
        activationsService.postImageActivation(formData).then((r) => {
          if (r.path) {
            setUrlFile(r.path);
            setLoadingImage(false);
          } else {
            setLoadingImage(false);
            setErrorFilePicker(true);
          }
        });
      } catch (error) {
        setLoadingImage(false);
        setErrorFilePicker(true);
      }
    }
  }, [fileValue]);

  const getActivationsData = () => {
    setLoadingTableData(true);
    activationsService.getActivations().then((r) => {
      getUrlImages(r).then((data) => {
        fillActivations(data);
      });

      activations.current = r;
    });
  };

  const getCreationData = () => {
    activationsService
      .getActivationCategories(languageId.value)
      .then((rc) => {
        const categories = rc.map((category: IActivationCategoryDto) => ({
          ...category,
          selected: false,
        }));
        setCategories(categories);
      })
      .then(() => {
        activationsService.getActivationFunds(languageId.value).then((rf) => {
          const funds = rf.map((fund: IActivationFundDto) => ({
            ...fund,
            selected: false,
          }));
          funds.push({
            fundID: rf.length + 1,
            fund: "otherFund",
            selected: false,
          });
          setFunds(funds);
        });
      });
  };

  useEffect(() => {
    setCreationDisable(true);
    getCreationData();
    getClassificationOptions();
  }, [languageId.value]);

  //useEffect for validate categories and funds
  useEffect(() => {
    if (categories.length > 0 && funds.length > 0) {
      setCreationDisable(false);
    } else {
      setCreationDisable(true);
    }
  }, [categories, funds]);

  //useEffect for validate fundsSelected
  useEffect(() => {
    if (funds.some((item) => item.selected === true)) {
      let existOther = funds.find((item) => item.fund === "otherFund");
      if (existOther?.selected) {
        otherFund.length > 2 ? setValidateFunds(false) : setValidateFunds(true);
      } else {
        setValidateFunds(false);
      }
    } else {
      setValidateFunds(true);
    }
  }, [funds, otherFund]);

  //useEffect for validate SubcategoriesSelected
  useEffect(() => {
    if (categorySelected === 2) {
      if (categories.some((item) => item.selected === true)) {
        setValidateSubcategories(false);
      } else {
        setValidateSubcategories(true);
      }
    } else {
      if (
        categories.some((item) => item.selected === true) &&
        families.length > 0
      ) {
        setValidateSubcategories(false);
      } else {
        setValidateSubcategories(true);
      }
    }
  }, [categories, families]);

  //useEffect for validate FamiliesSelected
  useEffect(() => {
    if (families.some((item) => item.selected === true)) {
      setValidateFamilies(false);
    } else {
      setValidateFamilies(true);
    }
  }, [families]);

  //useEffect for validate TypesSelected
  useEffect(() => {
    if (!Number.isNaN(typeSelected)) {
      setValidateTypes(false);
    } else {
      setValidateTypes(true);
    }
  }, [typeSelected]);

  useEffect(() => {
    if (technologies.some((item) => item.selected === true)) {
      setValidateTechnologies(false);
    } else {
      setValidateTechnologies(true);
    }
  }, [technologies]);

  useEffect(() => {
    setValidateClassification(Number.isNaN(classificationSelected) || !classificationSelected)
  }, [classificationSelected]);

  const fillActivations = (data: IActivationDto[]) => {
    const pagedData: TableData[] = [];
    for (let i = 0; i < data.length; i++) {
      const activation: IActivationDto = data[i];
      let tableData: TableData = {};
      tableData = {
        activationID: activation.activationID,
        name: activation.name,
        description: activation.description,
        urlImage: (
          <CustomImage
            size={144}
            quietArea={0}
            src={activation.urlImageSigned}
          />
        ),
        typeID: activation.typeID,
        isMarketingActivation: activation.isMarketingActivation
          ? t("header.yes")
          : t("header.no"),
        active: (
          <Toggle
            id={activation.name}
            on={activation.active}
            onChange={() =>
              handleChangeActive(activation.activationID, activation.active)
            }
          />
        ),
        rowConfig: {
          action: (
            <ContextualMenu
              onClick={handleActionRowConfig}
              options={[
                {
                  value: activation.activationID,
                  label: t("header.edit"),
                  icon: <IconPencil />,
                },
                {
                  value: activation.activationID,
                  label: t("header.delete"),
                  icon: <IconTrash />,
                },
              ]}
              placement="leading"
            />
          ),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      pagedData.push(tableData);
    }
    setTableData(pagedData);
    setTableDataFiltered(pagedData);
    setLoadingTableData(false);
  };

  async function getUrlImages(data: IActivationDto[]) {
    for (const activation of data) {
      if (activation.urlImage !== "") {
        try {
          const r = await ImageService.getFilePath(activation.urlImage);
          activation.urlImageSigned = r;
        } catch (error) {}
      } else {
        activation.urlImageSigned = "";
      }
    }
    return data;
  }

  const columns: TableColumns[] = [
    {
      id: "urlImage",
      label: t("header.image"),
    },
    {
      id: "name",
      label: t("header.name"),
    },
    {
      id: "description",
      label: t("header.description"),
    },
    {
      id: "isMarketingActivation",
      label: t("header.isMarketingActivation"),
    },
    {
      id: "active",
      label: t("header.active"),
    },
  ];

  const columnsWidth: TableColumnWidth[] = [
    {
      columnId: "urlImage",
      width: "25%",
    },
    {
      columnId: "name",
      width: "25%",
    },
    {
      columnId: "description",
      width: "25%",
    },
    {
      columnId: "isMarketingActivation",
      width: "12%",
    },
    {
      columnId: "active",
      width: "12%",
    },
  ];

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
  };

  const getClassificationOptions = () => {
    activationsService
      .getClassificationOptions(languageId.value)
      .then((options: IActivationsClassificationOptionsDto[]) => {
        setClassificationOptions(options);
      });
  };

  const formatDate = (date: Date) => {
    let day = ("0" + date.getDate()).slice(-2);
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let year = date.getFullYear();
    return year + "-" + month + "-" + day;
  };

  const handleChangeActive = (
    activationId: number,
    activationState: boolean
  ) => {
    setLoadingTableData(true);
    activationsService
      .updateStateActivation(activationId, !activationState)
      .then((r) => {
        getActivationsData();
      })
      .catch((error) => {});
  };

  const handleActionRowConfig = async (
    e: React.SyntheticEvent,
    option?: OptionInterface
  ) => {
    if (option) {
      if (
        option.label === "Edit" ||
        option.label === "Editar" ||
        option.label === "Editar"
      ) {
        setLoadingForEdit(true);
        setEditing(true);
        try {
          const activationActual = await getActivation(Number(option.value));
          if (!activationActual) {
            console.error("error");
            return;
          }
          setCategorySelected(activationActual.categoryID!);
          const response = await fillCategoriesEdit(activationActual);
          if (!response) {
            console.error("error");
            return;
          }

          await fillActivationEdit(activationActual);
          await fillActivationEditTechnologies(
            activationActual,
            activationActual.categoryID!
          );
          await fillActivationEditFamilies(activationActual, response);

          setLoadingForEdit(false);
          setShowModalCreateActivation(true);
        } catch (error) {
          setLoadingForEdit(false);
          clearCreationData();
          console.error(error);
        }
      } else if (
        option.label === "Delete" ||
        option.label === "Eliminar" ||
        option.label === "Excluir"
      ) {
        setActivationId(Number(option.value));
        setShowModalDeleteActivation(true);
      }
    }
  };

  async function getActivation(activationId: Number) {
    let activationActual = await activations.current.find(
      (item) => item.activationID === activationId
    );
    return activationActual;
  }

  async function fillCategoriesEdit(activation: IActivationDto) {
    let subcategoriesSelectedTemp = activation.subcategoryIDs?.split(",");
    let categoriesTemp: IActivationCategoryDto[] = [];

    await activationsService
      .getActivationCategories(languageId.value)
      .then((rc) => {
        categoriesTemp = rc.map((category: IActivationCategoryDto) => ({
          ...category,
          selected: false,
        }));
      });

    if (subcategoriesSelectedTemp) {
      for (const subcategory of subcategoriesSelectedTemp) {
        const subcategoryFund = categoriesTemp.find(
          (item) => item.categoryID === Number(subcategory)
        );
        if (subcategoryFund) {
          subcategoryFund.selected = true;
        }
      }
    }

    setCategories([...categoriesTemp]);
    return categoriesTemp;
  }

  async function fillActivationEdit(activation: IActivationDto) {
    setActivationId(activation.activationID);
    setName(activation.name);
    setDescription(activation.description);
    setIsMarketingActivation(activation.isMarketingActivation);
    setClassificationSelected(activation.classificationID);
    if (activation.urlImage) {
      setUrlFile(activation.urlImage);
      setFileName(activation.urlImage);
    }

    let fundsTemp: IActivationFundDto[] = [];
    await activationsService.getActivationFunds(languageId.value).then((rf) => {
      fundsTemp = rf.map((fund: IActivationFundDto) => ({
        ...fund,
        selected: false,
      }));
      fundsTemp.push({
        fundID: rf.length + 1,
        fund: "otherFund",
        selected: false,
      });
    });

    if (activation.funds !== null) {
      let fundsSelectedTemp = activation.funds.split(",");
      for (const fundT of fundsSelectedTemp) {
        const foundFund = fundsTemp.find((item) => item.fund === fundT);
        if (foundFund) {
          foundFund.selected = true;
          if (fundT === "otherFund") {
            setOtherFund(fundT);
          }
        } else {
          const otherFund = fundsTemp.find((item) => item.fund === "otherFund");
          if (otherFund) {
            otherFund.selected = true;
          }
          setOtherFund(fundT);
        }
      }
      setFunds([...fundsTemp]);
    }

    if (activation.productSKUs) {
      let productsSelectedTemp = activation.productSKUs.split(",");
      let productsTemp: IActivationProductDto[] = [];
      for await (const product of productsSelectedTemp) {
        productsTemp.push({
          sku: product,
          marketingName: product,
        });
      }
      setProductsSelected(productsTemp);
    }

    if (activation.printProductSKUs) {
      let printProductsSelectedTemp = activation.printProductSKUs.split(",");
      let printProductsTemp: IActivationProductDto[] = [];
      for await (const product of printProductsSelectedTemp) {
        printProductsTemp.push({
          sku: product,
          marketingName: product,
        });
      }
      setPrintProductsSelected(printProductsTemp);
    }
  }

  async function fillActivationEditTechnologies(
    activation: IActivationDto,
    categoryId: number
  ) {
    let technologiesTemp: IActivationTechnologyDto[] = [];
    await activationsService
      .getActivationTypes(categoryId, languageId.value)
      .then((r) => {
        setTypes(r);
      });
    setTypeSelected(activation.typeID);
    await activationsService
      .getActivationTechnologies(categoryId, languageId.value)
      .then((r) => {
        technologiesTemp = r.map((technology: IActivationTechnologyDto) => ({
          ...technology,
          selected: false,
        }));
      });

    if (activation.technologyIDs !== null) {
      let technologiesSelectedTemp = activation.technologyIDs.split(",");
      for await (const tech of technologiesSelectedTemp) {
        const techFund = technologiesTemp.find(
          (item) => item.technologyID === Number(tech)
        );
        if (techFund) {
          techFund.selected = true;
        }
      }
    }
    setTechnologies([...technologiesTemp]);
  }

  async function fillActivationEditFamilies(
    activation: IActivationDto,
    categoriesTemp: IActivationCategoryDto[]
  ) {
    let subcategoriesTemp = await categoriesTemp.filter(
      (sub) => sub.selected === true
    );
    const SubcategoryList: number[] = subcategoriesTemp.map(
      (item) => item.categoryID
    );
    const SubcategoryListJson = { SubcategoryList: SubcategoryList };
    let familiesTemp: IActivationFamilyDto[] = [];

    await activationsService
      .getActivationFamilies(
        JSON.stringify(SubcategoryListJson),
        languageId.value
      )
      .then((r) => {
        familiesTemp = r.map((family: IActivationFamilyDto) => ({
          ...family,
          selected: true,
        }));
      });
    if (activation.familyIDs !== null) {
      let familiesSelectedTemp = activation.familyIDs?.split(",");
      for await (const family of familiesSelectedTemp) {
        const familyFund = familiesTemp.find(
          (item) => item.familyID === Number(family)
        );
        if (familyFund) {
          familyFund.selected = true;
        }
      }
    }
    setFamilies([...familiesTemp]);
  }

  const handleChangeSearch = (value: string) => {
    setSearch(value);
    const filterArray = tableData.filter((element) => {
      if (
        element.name
          .toString()
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        element.activationID
          .toString()
          .toLowerCase()
          .includes(String(value).toLowerCase())
      ) {
        return element;
      }
    });
    setTableDataFiltered(filterArray);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setErrorFilePicker(false);
      setFileValue(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const onClearFilePicker = () => {
    setFileValue(null);
    setFileName("");
    setErrorFilePicker(false);
  };

  const handleChangeFunds = (fund: string) => {
    let fundsTemp = [...funds];
    let fundTemp = fundsTemp.find((item) => item.fund === fund);
    if (fundTemp) {
      fundTemp.selected = !fundTemp.selected;
    }
    setFunds([...fundsTemp]);
  };

  const handleChangeSubcategories = (subcategory: string) => {
    let categoriesTemp = [...categories];
    let categoryTemp = categoriesTemp.find(
      (item) => item.category === subcategory
    );
    if (categoryTemp) {
      categoryTemp.selected = !categoryTemp.selected;
    }
    setCategories([...categoriesTemp]);
  };

  const handleChangeFamilies = (family: string) => {
    let familiesTemp = [...families];
    let familyTemp = familiesTemp.find((item) => item.family === family);
    if (familyTemp) {
      familyTemp.selected = !familyTemp.selected;
    }
    setFamilies([...familiesTemp]);
  };

  const handleChangeTechnologies = (technlogy: string) => {
    let technologiesTemp = [...technologies];
    let tecnologyTemp = technologiesTemp.find(
      (item) => item.technology === technlogy
    );
    if (tecnologyTemp) {
      tecnologyTemp.selected = !tecnologyTemp.selected;
    }
    setTechnologies([...technologiesTemp]);
  };

  const searchProducts = () => {
    setLoadingProducts(true);
    activationsService
      .getActivationProducts(`${numberModel}-${model}`)
      .then((r) => {
        if (r.length > 0) {
          let productsSearchTemp = r;
          productsSelected.map((product) => {
            if (
              productsSearchTemp.find(
                (item: IActivationProductDto) => item.sku === product.sku
              )
            ) {
              productsSearchTemp = productsSearchTemp.filter(
                (item: IActivationProductDto) => item.sku !== product.sku
              );
            }
          });
          setLoadingProducts(false);
          setProductsSearch(productsSearchTemp);
          setShowModalProducts(true);
        } else {
          setLoadingProducts(false);
          setErrorSearchProducts(true);
        }
      });
  };

  const searchPrintProducts = () => {
    setLoadingPrintProducts(true);
    activationsService.getActivationPrintProducts(`${printModel}`).then((r) => {
      if (r.length > 0) {
        let printProductsSearchTemp = r;
        printProductsSelected.map((product) => {
          if (
            printProductsSearchTemp.find(
              (item: IActivationProductDto) => item.sku === product.sku
            )
          ) {
            printProductsSearchTemp = printProductsSearchTemp.filter(
              (item: IActivationProductDto) => item.sku !== product.sku
            );
          }
        });
        setLoadingPrintProducts(false);
        setPrintProductsSearch(printProductsSearchTemp);
        setShowModalPrintProducts(true);
      } else {
        setLoadingPrintProducts(false);
        setErrorSearchPrintProducts(true);
      }
    });
  };

  const closeModalProducts = () => {
    setShowModalProducts(false);
    setProductsSearch([]);
  };

  const closeModalPrintProducts = () => {
    setShowModalPrintProducts(false);
    setPrintProductsSearch([]);
  };

  const addProducts = (sku: string) => {
    const productTemp = productsSearch.find((product) => product.sku === sku);
    setProductsSelected([...productsSelected, productTemp!]);
    const productsSearchTemp = productsSearch.filter(
      (product) => product.sku !== sku
    );
    setProductsSearch([...productsSearchTemp]);
  };

  const addPrintProducts = (sku: string) => {
    const productTemp = printProductsSearch.find(
      (product) => product.sku === sku
    );
    setPrintProductsSelected([...printProductsSelected, productTemp!]);
    const printProductsSearchTemp = printProductsSearch.filter(
      (product) => product.sku !== sku
    );
    setPrintProductsSearch([...printProductsSearchTemp]);
  };

  const deleteProducts = (sku: string) => {
    const productsSelectedTemp = productsSelected.filter(
      (product) => product.sku !== sku
    );
    setProductsSelected([...productsSelectedTemp]);
  };

  const deletePrintProducts = (sku: string) => {
    const printProductsSelectedTemp = printProductsSelected.filter(
      (product) => product.sku !== sku
    );
    setPrintProductsSelected([...printProductsSelectedTemp]);
  };

  const clearCreationData = () => {
    setViewCreationModal(0);
    setCategorySelected(1);
    setProductsSelected([]);
    setProductsSearch([]);
    setPrintProductsSelected([]);
    setPrintProductsSearch([]);
    setNumberModel("");
    setModel("");
    setPrintModel("");
    setOtherFund("");
    setName("");
    setDescription("");
    setUrlFile("");
    setFileName("");
    setTypeSelected(NaN);
    setClassificationSelected(NaN);
    setEditing(false);
    setIsMarketingActivation(false);

    const fundsTemp: IActivationFundDto[] = funds.map((fund) => ({
      ...fund,
      selected: false,
    }));
    setFunds(fundsTemp);

    const categoriesTemp: IActivationCategoryDto[] = categories.map(
      (category) => ({
        ...category,
        selected: false,
      })
    );
    setCategories(categoriesTemp);

    const familiesTemp: IActivationFamilyDto[] = families.map((family) => ({
      ...family,
      selected: false,
    }));
    setFamilies(familiesTemp);

    const technologiesTemp: IActivationTechnologyDto[] = technologies.map(
      (technolgy) => ({
        ...technolgy,
        selected: false,
      })
    );
    setTechnologies(technologiesTemp);
  };

  const cancelCreateActivation = () => {
    setShowModalCreateActivation(false);
    clearCreationData();
  };

  const submitCreateActivation = () => {
    setLoadingSubmit(true);
    let fundsTemp = funds.filter((fund) => fund.selected === true);
    let subcategoriesTemp = categories.filter((sub) => sub.selected === true);
    let familiesTemp = families.filter((family) => family.selected === true);
    let technologiesTemp = technologies.filter(
      (tech) => tech.selected === true
    );
    let productsTemp = productsSelected.map((product) => product.sku);
    let printProductsTemp = printProductsSelected.map((product) => product.sku);
    let date = new Date();

    let activationIn: IActivationIn = {
      name: "",
      description: "",
      categoryID: 0,
      urlImage: "",
      active: true,
      dateCreated: "",
      dateModified: "",
      typeID: 0,
      isMarketingActivation: false,
      classificationID: 0,
      funds: [],
      subcategoryIds: [],
      familyIds: [],
      technologyIds: [],
      productSKUs: [],
      printProductSKUs: [],
    };

    if (categorySelected === 1) {
      activationIn = {
        name: name,
        description: description,
        categoryID: categorySelected,
        urlImage: urlFile ? urlFile : "",
        typeID: typeSelected,
        active: true,
        dateCreated: formatDate(date),
        dateModified: formatDate(date),
        isMarketingActivation: isMarketingActivation,
        classificationID: classificationSelected,
        funds: fundsTemp
          ? fundsTemp.map((item) =>
              item.fund === "otherFund" ? otherFund : item.fund
            )
          : [],
        subcategoryIds: subcategoriesTemp.map((item) => item.categoryID),
        familyIds: familiesTemp.map((item) => item.familyID),
        technologyIds: technologiesTemp.map((item) => item.technologyID),
        productSKUs: productsTemp ? productsTemp : [],
        printProductSKUs: [],
      };
    } else if (categorySelected === 2) {
      activationIn = {
        name: name,
        description: description,
        categoryID: categorySelected,
        urlImage: urlFile ? urlFile : "",
        typeID: typeSelected,
        active: true,
        isMarketingActivation: isMarketingActivation,
        classificationID: classificationSelected,
        dateCreated: formatDate(date),
        dateModified: formatDate(date),
        funds: [],
        subcategoryIds: subcategoriesTemp.map((item) => item.categoryID),
        familyIds: [],
        technologyIds: technologiesTemp.map((item) => item.technologyID),
        productSKUs: [],
        printProductSKUs: printProductsTemp ? printProductsTemp : [],
      };
    } else {
      activationIn = {
        name: name,
        description: description,
        categoryID: categorySelected,
        urlImage: urlFile ? urlFile : "",
        typeID: typeSelected,
        active: true,
        isMarketingActivation: isMarketingActivation,
        classificationID: classificationSelected,
        dateCreated: formatDate(date),
        dateModified: formatDate(date),
        funds: fundsTemp
          ? fundsTemp.map((item) =>
              item.fund === "otherFund" ? otherFund : item.fund
            )
          : [],
        subcategoryIds: subcategoriesTemp.map((item) => item.categoryID),
        familyIds: familiesTemp.map((item) => item.familyID),
        technologyIds: technologiesTemp.map((item) => item.technologyID),
        productSKUs: productsTemp ? productsTemp : [],
        printProductSKUs: printProductsTemp ? printProductsTemp : [],
      };
    }
    try {
      activationsService.postActivation(activationIn).then((r) => {
        setShowModalCreateActivation(false);
        setLoadingSubmit(false);
        getActivationsData();
        clearCreationData();
      });
    } catch (error) {
      setShowModalCreateActivation(false);
      setLoadingSubmit(false);
    }
  };

  const updateActivation = () => {
    setLoadingSubmit(true);
    let fundsTemp = funds.filter((fund) => fund.selected === true);
    let subcategoriesTemp = categories.filter((sub) => sub.selected === true);
    let familiesTemp = families.filter((family) => family.selected === true);
    let technologiesTemp = technologies.filter(
      (tech) => tech.selected === true
    );
    let productsTemp = productsSelected.map((product) => product.sku);
    let printProductsTemp = printProductsSelected.map((product) => product.sku);
    let date = new Date();

    let activationUpdateIn: IActivationUpdateIn = {
      activationID: 0,
      name: "",
      description: "",
      categoryID: 0,
      urlImage: "",
      typeID: 0,
      active: true,
      isMarketingActivation: false,
      classificationID: 0,
      dateModified: "",
      funds: [],
      subcategoryIds: [],
      familyIds: [],
      technologyIds: [],
      productSKUs: [],
      printProductSKUs: [],
    };

    if (categorySelected === 1) {
      activationUpdateIn = {
        activationID: activationId,
        name: name,
        description: description,
        categoryID: categorySelected,
        urlImage: urlFile ? urlFile : "",
        typeID: typeSelected,
        active: true,
        dateModified: formatDate(date),
        isMarketingActivation: isMarketingActivation,
        classificationID: classificationSelected,
        funds: fundsTemp
          ? fundsTemp.map((item) =>
              item.fund === "otherFund" ? otherFund : item.fund
            )
          : [],
        subcategoryIds: subcategoriesTemp.map((item) => item.categoryID),
        familyIds: familiesTemp.map((item) => item.familyID),
        technologyIds: technologiesTemp.map((item) => item.technologyID),
        productSKUs: productsTemp ? productsTemp : [],
        printProductSKUs: [],
      };
    } else if (categorySelected === 2) {
      activationUpdateIn = {
        activationID: activationId,
        name: name,
        description: description,
        categoryID: categorySelected,
        urlImage: urlFile ? urlFile : "",
        typeID: typeSelected,
        active: true,
        isMarketingActivation: isMarketingActivation,
        classificationID: classificationSelected,
        dateModified: formatDate(date),
        funds: [],
        subcategoryIds: subcategoriesTemp.map((item) => item.categoryID),
        familyIds: [],
        technologyIds: technologiesTemp.map((item) => item.technologyID),
        productSKUs: [],
        printProductSKUs: printProductsTemp ? printProductsTemp : [],
      };
    } else {
      activationUpdateIn = {
        activationID: activationId,
        name: name,
        description: description,
        categoryID: categorySelected,
        urlImage: urlFile ? urlFile : "",
        typeID: typeSelected,
        active: true,
        isMarketingActivation: isMarketingActivation,
        classificationID: classificationSelected,
        dateModified: formatDate(date),
        funds: fundsTemp
          ? fundsTemp.map((item) =>
              item.fund === "otherFund" ? otherFund : item.fund
            )
          : [],
        subcategoryIds: subcategoriesTemp.map((item) => item.categoryID),
        familyIds: familiesTemp.map((item) => item.familyID),
        technologyIds: technologiesTemp.map((item) => item.technologyID),
        productSKUs: productsTemp ? productsTemp : [],
        printProductSKUs: printProductsTemp ? printProductsTemp : [],
      };
    }

    try {
      activationsService.updateActivation(activationUpdateIn).then((r) => {
        setShowModalCreateActivation(false);
        setLoadingSubmit(false);
        getActivationsData();
        clearCreationData();
      });
    } catch (error) {
      setShowModalCreateActivation(false);
      setLoadingSubmit(false);
    }
  };

  const deleteActivation = () => {
    activationsService.deleteActivation(activationId).then((r) => {
      setShowModalDeleteActivation(false);
      getActivationsData();
    });
  };

  const cancelDeleteActivation = () => {
    setShowModalDeleteActivation(false);
  };

  const renderResume = (categoryId: number) => {
    switch (categoryId) {
      case 1:
        return (
          <div className="activationResume">
            <label>
              <b>{t("header.description")}:</b> {description}
            </label>
            <label>
              <b>{t("header.category")}:</b>{" "}
              {
                categories.find(
                  (category) => category.categoryID === categorySelected
                )?.category
              }
            </label>
            <label>
              <b>{t("header.funds")}:</b>{" "}
              {funds.map((fund) =>
                fund.selected === true
                  ? fund.fund === "otherFund"
                    ? otherFund + " / "
                    : fund.fund + " / "
                  : null
              )}
            </label>
            <label>
              <b>{t("header.subcategories")}:</b>{" "}
              {categories.map((sub) =>
                sub.selected === true ? sub.category + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.families")}:</b>{" "}
              {families.map((family) =>
                family.selected === true ? family.family + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.productsActivation")}:</b>{" "}
              {productsSelected.map((product) => product.marketingName)}
            </label>
            <label>
              <b>{t("header.type")}:</b>{" "}
              {types.find((type) => type.typeID === typeSelected)?.type}
            </label>
            <label>
              <b>{t("header.isActivationOfMarketing")}:</b>{" "}
              {isMarketingActivation ? t("header.yes") : t("header.no")}
            </label>
            <label>
              <b>{t("header.activationClassification")}</b>
              {
                classificationOptions.find(
                  (option) => option.classificationID === classificationSelected
                )?.name
              }
            </label>
            <label>
              <b>{t("header.technologies")}:</b>{" "}
              {technologies.map((tech) =>
                tech.selected === true ? tech.technology + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.imageName")}:</b> {fileName}
            </label>
          </div>
        );
        break;
      case 2:
        return (
          <div className="activationResume">
            <label>
              <b>{t("header.description")}:</b> {description}
            </label>
            <label>
              <b>{t("header.category")}:</b>{" "}
              {
                categories.find(
                  (category) => category.categoryID === categorySelected
                )?.category
              }
            </label>
            <label>
              <b>{t("header.subcategories")}:</b>{" "}
              {categories.map((sub) =>
                sub.selected === true ? sub.category + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.families")}:</b>{" "}
              {families.map((family) =>
                family.selected === true ? family.family + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.printProductsActivation")}:</b>{" "}
              {printProductsSelected.map((product) => product.marketingName)}
            </label>
            <label>
              <b>{t("header.type")}:</b>{" "}
              {types.find((type) => type.typeID === typeSelected)?.type}
            </label>
            <label>
              <b>{t("header.isActivationOfMarketing")}:</b>{" "}
              {isMarketingActivation ? t("header.yes") : t("header.no")}
            </label>
            <label>
              <b>{t("header.activationClassification")}</b>
              {
                classificationOptions.find(
                  (option) => option.classificationID === classificationSelected
                )?.name
              }
            </label>
            <label>
              <b>{t("header.technologies")}:</b>{" "}
              {technologies.map((tech) =>
                tech.selected === true ? tech.technology + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.imageName")}:</b> {fileName}
            </label>
          </div>
        );
        break;
      case 3:
        return (
          <div className="activationResume">
            <label>
              <b>{t("header.description")}:</b> {description}
            </label>
            <label>
              <b>{t("header.category")}:</b>{" "}
              {
                categories.find(
                  (category) => category.categoryID === categorySelected
                )?.category
              }
            </label>
            <label>
              <b>{t("header.funds")}:</b>{" "}
              {funds.map((fund) =>
                fund.selected === true
                  ? fund.fund === "otherFund"
                    ? otherFund + " / "
                    : fund.fund + " / "
                  : null
              )}
            </label>
            <label>
              <b>{t("header.subcategories")}:</b>{" "}
              {categories.map((sub) =>
                sub.selected === true ? sub.category + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.families")}:</b>{" "}
              {families.map((family) =>
                family.selected === true ? family.family + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.productsActivation")}:</b>{" "}
              {productsSelected.map((product) => product.marketingName)}
            </label>
            <label>
              <b>{t("header.printProductsActivation")}:</b>{" "}
              {printProductsSelected.map((product) => product.marketingName)}
            </label>
            <label>
              <b>{t("header.type")}:</b>{" "}
              {types.find((type) => type.typeID === typeSelected)?.type}
            </label>
            <label>
              <b>{t("header.isActivationOfMarketing")}:</b>{" "}
              {isMarketingActivation ? t("header.yes") : t("header.no")}
            </label>
            <label>
              <b>{t("header.activationClassification")}</b>
              {
                classificationOptions.find(
                  (option) => option.classificationID === classificationSelected
                )?.name
              }
            </label>
            <label>
              <b>{t("header.technologies")}:</b>{" "}
              {technologies.map((tech) =>
                tech.selected === true ? tech.technology + " / " : null
              )}
            </label>
            <label>
              <b>{t("header.imageName")}:</b> {fileName}
            </label>
          </div>
        );
        break;
      default:
        return <p>{t("header.error")}</p>;
    }
  };

  return (
    <div className="activationsCreation">
      {loadingForEdit ? <Loader /> : null}

      <h4 className="activationsCreationTittle">{t("header.activations")}</h4>

      <div className="activationsCreationTop">
        <TextBox
          id="activationsCreationTextbox"
          className="activationsCreationTextbox"
          label={t("header.search")}
          type="search"
          onChange={handleChangeSearch}
          value={search}
        />

        <Button
          disabled={creationDisable}
          onClick={() => setShowModalCreateActivation(true)}
        >
          {t("header.createActivation")}
        </Button>
      </div>

      <Card
        appearance="outlined"
        className="activationsCreationCard"
        content={
          <Table
            className="activationsCreationTable"
            behavior={{
              type: "singlePage",
            }}
            columnResize
            preferences={tablePreferences}
            loading={loadingTableData}
            columns={columns}
            data={tableDataFiltered}
            loadingDataLength={10}
            customNoItems={
              <div className="customNoItems">
                <div className="DivIconCustomNoItems">
                  <IconWarningAlt className="IconCustomNoItems" />
                </div>
                {t("header.noItemsFound")}
              </div>
            }
          />
        }
      />

      <div style={{ position: "relative" }}>
        <Modal
          className="modalCreateActivation"
          closeButton={true}
          align="center"
          id="modalCreateActivation"
          show={showModalCreateActivation}
          onClose={cancelCreateActivation}
          footer={(() => {
            switch (categorySelected) {
              case 1:
                if (viewCreationModal === 0) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button
                        disabled={false}
                        onClick={() => setViewCreationModal(1)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 1) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(0)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateFunds}
                        onClick={() => setViewCreationModal(2)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 2) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(1)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateSubcategories}
                        onClick={() => setViewCreationModal(3)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 3) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(2)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateFamilies}
                        onClick={() => setViewCreationModal(4)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 4) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(3)}>
                        {t("header.previous")}
                      </Button>
                      <Button onClick={() => setViewCreationModal(6)}>
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 6) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(4)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateClassification}
                        onClick={() => setViewCreationModal(7)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 7) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(6)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTypes}
                        onClick={() => setViewCreationModal(8)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 8) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(7)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTechnologies}
                        onClick={() => setViewCreationModal(9)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 9) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(8)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTechnologies}
                        onClick={() => setViewCreationModal(10)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 10) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(9)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateDisable}
                        onClick={() => setViewCreationModal(11)}
                      >
                        {t("header.validate")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 11) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(10)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={submitDisable}
                        onClick={
                          editing ? updateActivation : submitCreateActivation
                        }
                      >
                        {editing ? t("header.update") : t("header.submit")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                }
                break;
              case 2:
                if (viewCreationModal === 0) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button
                        disabled={false}
                        onClick={() => setViewCreationModal(2)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 2) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(0)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateSubcategories}
                        onClick={() => setViewCreationModal(3)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 3) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(2)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateFamilies}
                        onClick={() => setViewCreationModal(5)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 5) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(3)}>
                        {t("header.previous")}
                      </Button>
                      <Button onClick={() => setViewCreationModal(6)}>
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 6) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(5)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateClassification}
                        onClick={() => setViewCreationModal(7)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 7) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(6)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTypes}
                        onClick={() => setViewCreationModal(8)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 8) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(7)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTechnologies}
                        onClick={() => setViewCreationModal(9)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 9) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(8)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTechnologies}
                        onClick={() => setViewCreationModal(10)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 10) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(9)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateDisable}
                        onClick={() => setViewCreationModal(11)}
                      >
                        {t("header.validate")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 11) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(10)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={submitDisable}
                        onClick={
                          editing ? updateActivation : submitCreateActivation
                        }
                      >
                        {editing ? t("header.update") : t("header.submit")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                }
                break;
              case 3:
                if (viewCreationModal === 0) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button
                        disabled={false}
                        onClick={() => setViewCreationModal(1)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 1) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(0)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateFunds}
                        onClick={() => setViewCreationModal(2)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 2) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(1)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateSubcategories}
                        onClick={() => setViewCreationModal(3)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 3) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(2)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateFamilies}
                        onClick={() => setViewCreationModal(4)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 4) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(3)}>
                        {t("header.previous")}
                      </Button>
                      <Button onClick={() => setViewCreationModal(5)}>
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 5) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(4)}>
                        {t("header.previous")}
                      </Button>
                      <Button onClick={() => setViewCreationModal(6)}>
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 6) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(5)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateClassification}
                        onClick={() => setViewCreationModal(7)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 7) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(6)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTypes}
                        onClick={() => setViewCreationModal(8)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 8) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(7)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTechnologies}
                        onClick={() => setViewCreationModal(9)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 9) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(8)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateTechnologies}
                        onClick={() => setViewCreationModal(10)}
                      >
                        {t("header.next")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 10) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(9)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={validateDisable}
                        onClick={() => setViewCreationModal(11)}
                      >
                        {t("header.validate")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                } else if (viewCreationModal === 11) {
                  return (
                    <ButtonGroup className="registerSaleButtongrouop">
                      <Button onClick={() => setViewCreationModal(10)}>
                        {t("header.previous")}
                      </Button>
                      <Button
                        disabled={submitDisable}
                        onClick={
                          editing ? updateActivation : submitCreateActivation
                        }
                      >
                        {editing ? t("header.update") : t("header.submit")}
                      </Button>
                      <Button
                        onClick={cancelCreateActivation}
                        appearance="secondary"
                      >
                        {t("header.cancel")}
                      </Button>
                    </ButtonGroup>
                  );
                }
                break;
              default:
                <p>{t("header.error")}</p>;
            }
          })()}
          title={
            editing
              ? t("header.updateActivation")
              : t("header.createActivation")
          }
        >
          {(() => {
            if (viewCreationModal === 0) {
              return (
                <div>
                  <h6>{t("header.activationCategorySelect")}</h6>
                  <RadioButtons
                    alignment="vertical"
                    name={`radio-categories`}
                    value={categorySelected}
                  >
                    {categories
                      .filter((category) => category.parent == null)
                      .map((category, indexCategory) => (
                        <RadioButton
                          id={category.category}
                          key={category.category}
                          value={category.categoryID}
                          label={category.category}
                          onClick={(e) =>
                            setCategorySelected(category.categoryID)
                          }
                        />
                      ))}
                  </RadioButtons>
                </div>
              );
            } else if (viewCreationModal === 1) {
              return (
                <div>
                  <h6>{t("header.activationFundSelect")}</h6>
                  <div className="modalCreateActivationChecks">
                    {funds.map((fund) =>
                      fund.fund === "otherFund" ? (
                        <div
                          key={fund.fund}
                          className="modalCreateActivationChecksOther"
                        >
                          <Checkbox
                            className="modalCreateActivationCheck"
                            id={fund.fund}
                            key={fund.fund}
                            checked={fund.selected}
                            value={fund.selected}
                            label={t("header.otherWhichOne")}
                            onChange={() => handleChangeFunds(fund.fund)}
                          />
                          <TextBox
                            className="modalCreateActivationProductsTextbox"
                            id={fund.fund}
                            value={otherFund}
                            onChange={(value) => setOtherFund(value)}
                          />
                        </div>
                      ) : (
                        <Checkbox
                          className="modalCreateActivationCheck"
                          id={fund.fund}
                          key={fund.fund}
                          checked={fund.selected}
                          value={fund.selected}
                          label={fund.fund}
                          onChange={() => handleChangeFunds(fund.fund)}
                        />
                      )
                    )}
                  </div>
                </div>
              );
            } else if (viewCreationModal === 2) {
              return (
                <div>
                  <h6>{t("header.activationSubcategoriesSelect")}</h6>
                  <div className="modalCreateActivationChecks">
                    {categorySelected === 3
                      ? categories
                          .filter((category) => category.parent !== null)
                          .map((category, indexCategory) => (
                            <Checkbox
                              className="modalCreateActivationCheck"
                              id={category.category}
                              key={category.category}
                              checked={category.selected}
                              value={category.selected}
                              label={category.category}
                              onChange={() =>
                                handleChangeSubcategories(category.category)
                              }
                            />
                          ))
                      : categories
                          .filter(
                            (category) => category.parent == categorySelected
                          )
                          .map((category, indexCategory) => (
                            <Checkbox
                              className="modalCreateActivationCheck"
                              id={category.category}
                              key={category.category}
                              checked={category.selected}
                              value={category.selected}
                              label={category.category}
                              onChange={() =>
                                handleChangeSubcategories(category.category)
                              }
                            />
                          ))}
                  </div>
                </div>
              );
            } else if (viewCreationModal === 3) {
              return (
                <div>
                  <h6>{t("header.activationFamiliesSelect")}</h6>
                  <div className="modalCreateActivationChecks">
                    {families.map((family, indexFamily) => (
                      <Checkbox
                        className="modalCreateActivationCheck"
                        id={family.family}
                        key={family.family}
                        checked={family.selected}
                        value={family.selected}
                        label={family.family}
                        onChange={() => handleChangeFamilies(family.family)}
                      />
                    ))}
                  </div>
                </div>
              );
            } else if (viewCreationModal === 4) {
              return (
                <div>
                  <h6>{t("header.activationProductsSelect")}</h6>

                  <div className="modalCreateActivationProductsTextboxs">
                    {loadingProducts ? <LoaderModal /> : null}
                    <TextBox
                      className="modalCreateActivationProductsTextbox"
                      label={t("header.numbers")}
                      id="activation-number"
                      type="search"
                      onChange={(value) => setNumberModel(value)}
                      value={numberModel}
                      error={errorSearchProducts}
                      helperText={t("header.helperProductsActivation")}
                    />
                    <TextBox
                      className="modalCreateActivationProductsTextbox"
                      label={t("header.letters")}
                      id="activation-model"
                      type="search"
                      onChange={(value) => setModel(value)}
                      value={model}
                      error={errorSearchProducts}
                    />
                    <Button
                      className="modalCreateActivationProductsButton"
                      leadingIcon={<IconSearch />}
                      disabled={searchProductsDisable}
                      onClick={() => searchProducts()}
                    />
                  </div>

                  {errorSearchProducts ? (
                    <b>{t("header.errorSearchProductsActivation")}</b>
                  ) : null}
                  <List>
                    {productsSelected?.map((product, indexProduct) => {
                      return (
                        <ListItem
                          leadingArea={product.marketingName}
                          trailingArea={
                            <Button
                              leadingIcon={<IconTrash />}
                              onClick={() => deleteProducts(product.sku)}
                            />
                          }
                        />
                      );
                    })}
                  </List>
                </div>
              );
            } else if (viewCreationModal === 5) {
              return (
                <div>
                  <h6>{t("header.activationPrintProductsSelect")}</h6>

                  <div className="modalCreateActivationPrintProductsTextboxs">
                    {loadingPrintProducts ? <LoaderModal /> : null}
                    <TextBox
                      className="modalCreateActivationPrintProductsTextbox"
                      label={t("header.search")}
                      id="activation-printModel"
                      type="search"
                      onChange={(value) => setPrintModel(value)}
                      value={printModel}
                      error={errorSearchPrintProducts}
                      helperText={t("header.helperPrintProductsActivation")}
                    />
                    <Button
                      className="modalCreateActivationPrintProductsButton"
                      leadingIcon={<IconSearch />}
                      disabled={searchPrintProductsDisable}
                      onClick={() => searchPrintProducts()}
                    />
                  </div>

                  {errorSearchPrintProducts ? (
                    <b>{t("header.errorSearchProductsActivation")}</b>
                  ) : null}
                  <List>
                    {printProductsSelected?.map((product, indexProduct) => {
                      return (
                        <ListItem
                          leadingArea={product.marketingName}
                          trailingArea={
                            <Button
                              leadingIcon={<IconTrash />}
                              onClick={() => deletePrintProducts(product.sku)}
                            />
                          }
                        />
                      );
                    })}
                  </List>
                </div>
              );
            } else if (viewCreationModal === 6) {
              return (
                <div className="modalCreateActivationTypes">
                  <h6>{t("header.activationClassification")}</h6>
                  <RadioButtons
                    alignment="vertical"
                    name="radio-classifications"
                    value={classificationSelected}
                  >
                    {classificationOptions.map((option) => (
                        <RadioButton
                          id={option.name}
                          key={option.name}
                          value={option.classificationID}
                          label={(
                            <div className="container-classsification-option">
                            <span>{option.label}</span>
                            <Tooltip
                              arrow
                              content={option.description.replace( /[\r\n]+/gm, "").split("<br/>").map((subStr) => {
                                let str = subStr.trim();
                                if (str === "")
                                  return "";

                                return (
                                  <>
                                    {str}
                                    <br />
                                    <br />
                                  </>
                                )
                              })}
                              contentHideDelayOnHover={300}
                              contentShowDelayOnHover={0}
                              placement="trailing-start"
                            >
                              <IconInfo aria-label="info icon" />
                            </Tooltip>
                            </div>
                          )}
                          name="radio-classifications"
                          aria-describedby="radio-classifications"
                          onClick={(e) =>
                            setClassificationSelected(option.classificationID)
                          }
                        />
                    ))}
                  </RadioButtons>
                </div>
              );
            } else if (viewCreationModal === 7) {
              return (
                <div className="modalCreateActivationTypes">
                  <h6>{t("header.activationTypesSelect")}</h6>
                  <RadioButtons
                    alignment="vertical"
                    name={`radio-types`}
                    value={typeSelected}
                  >
                    {types.map((type) => (
                      <RadioButton
                        id={type.type}
                        key={type.type}
                        value={type.typeID}
                        label={type.type}
                        onClick={(e) => setTypeSelected(type.typeID)}
                      />
                    ))}
                  </RadioButtons>
                </div>
              );
            } else if (viewCreationModal === 8) {
              return (
                <div>
                  <h6>{t("header.activationTechnologiesSelect")}</h6>
                  <div className="modalCreateActivationChecks">
                    {technologies.map((technology) => (
                      <Checkbox
                        className="modalCreateActivationCheck"
                        id={technology.technology}
                        key={technology.technology}
                        checked={technology.selected}
                        value={technology.selected}
                        label={technology.technology}
                        onChange={() =>
                          handleChangeTechnologies(technology.technology)
                        }
                      />
                    ))}
                  </div>
                </div>
              );
            } else if (viewCreationModal === 9) {
              return (
                <div className="modalCreateActivationCheckIsMarketing">
                  <Checkbox
                    id="checkbox"
                    key="isMarketinActivationKey"
                    label={t("header.isActivationOfMarketing")}
                    checked={isMarketingActivation}
                    onChange={() => setIsMarketingActivation((prev) => !prev)}
                  />
                </div>
              );
            } else if (viewCreationModal === 10) {
              return (
                <div>
                  {loadingImage ? <LoaderModal /> : null}
                  <h6>{t("header.activationNameSelect")}</h6>
                  <div className="modalCreateActivationName">
                    <TextBox
                      className="modalCreateActivationNameText"
                      label={t("header.name")}
                      id="activation-name"
                      onChange={(value) => setName(value)}
                      value={name}
                    />
                    <TextArea
                      className="modalCreateActivationNameText"
                      label={t("header.description")}
                      id="activation-description"
                      onChange={(value) => setDescription(value)}
                      value={description}
                    />
                  </div>
                  <h6>{t("header.activationPhotoSelect")}</h6>

                  <FilePicker
                    className="modalCreateActivationFile"
                    id="activation-file-picker"
                    label={t("header.uploadFile")}
                    accept=".jpg,.jpeg,.png"
                    onChange={handleFileChange}
                    onClear={onClearFilePicker}
                    value={fileName}
                    error={errorFilePicker}
                    helperText={t("header.helperUploadFileActivation")}
                  />
                </div>
              );
            } else if (viewCreationModal === 11) {
              return (
                <div>
                  {loadingSubmit ? <LoaderModal /> : null}
                  <h6>
                    <b>{t("header.activationResume")}</b> {name}
                  </h6>
                  {renderResume(categorySelected)}
                </div>
              );
            }
          })()}
        </Modal>
      </div>

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modalDeleteACtivation"
          show={showModalDeleteActivation}
          onClose={cancelDeleteActivation}
          footer={
            <ButtonGroup className="deleteActivationButtongrouop">
              <Button onClick={deleteActivation}>{t("header.yes")}</Button>
              <Button onClick={cancelDeleteActivation} appearance="secondary">
                {t("header.cancel")}
              </Button>
            </ButtonGroup>
          }
          title={t("header.deleteItem")}
        >
          <p>{t("header.questionDelete")}</p>
        </Modal>
      </div>

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modalProducts"
          show={showModalProducts}
          closeButton
          onClose={closeModalProducts}
          title={t("header.products")}
        >
          <div className="modalProductsList">
            {productsSearch?.map((product) => {
              return (
                <ListItem
                  leadingArea={product.marketingName}
                  trailingArea={
                    <Button
                      leadingIcon={<IconPlus />}
                      onClick={() => addProducts(product.sku)}
                    />
                  }
                />
              );
            })}
          </div>
        </Modal>
      </div>

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modalPrintProducts"
          show={showModalPrintProducts}
          closeButton
          onClose={closeModalPrintProducts}
          title={t("header.printProducts")}
        >
          <div className="modalPrintProductsList">
            {printProductsSearch?.map((product) => {
              return (
                <ListItem
                  leadingArea={product.marketingName}
                  trailingArea={
                    <Button
                      leadingIcon={<IconPlus />}
                      onClick={() => addPrintProducts(product.sku)}
                    />
                  }
                />
              );
            })}
          </div>
        </Modal>
      </div>
    </div>
  );
}
